function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { FilterType as Type } from 'swag-client-common/interfaces/filters';
import { NON_DATA_IS_ATTRIBUTE_FILTERS, NON_DATA_IS_ATTRIBUTE_FILTERS_FOR_CURATED_BRAND_STORE } from 'swag-common/constants/product.constants';
import classes from './filter-list.scss';
import appearAnimationClasses from './appear.anim.scss';
class FilterList extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.isLoading) {
      return _objectSpread({}, prevState);
    } else {
      return _objectSpread({}, nextProps);
    }
  }
  constructor(props) {
    super(props);
    this.state = props;
  }
  render() {
    const {
      productAttributes,
      FilterItemComponent,
      categories,
      colorFamily,
      pricing,
      productionTime,
      minQuantity,
      shouldShowBackLink,
      secondaryColor = '',
      isCuratedBrandStore,
      categoriesAndFiltersAreHiddenForCBS
    } = this.state;
    const nonDataIsAttributeFilters = isCuratedBrandStore ? NON_DATA_IS_ATTRIBUTE_FILTERS_FOR_CURATED_BRAND_STORE : NON_DATA_IS_ATTRIBUTE_FILTERS;
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.wrapper, {
        [classes.searchWrapper]: !shouldShowBackLink
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.filtersList
    }, !categoriesAndFiltersAreHiddenForCBS && /*#__PURE__*/React.createElement(CSSTransition, {
      in: !!categories,
      timeout: 500,
      classNames: appearAnimationClasses,
      unmountOnExit: true
    }, /*#__PURE__*/React.createElement(FilterItemComponent, {
      color: secondaryColor,
      filterItem: categories,
      type: Type.CHECKBOX,
      maxItemsCountToShow: 5
    })), /*#__PURE__*/React.createElement(FilterItemComponent, {
      color: secondaryColor,
      filterItem: pricing,
      type: Type.PRICE_RANGE
    }), /*#__PURE__*/React.createElement(CSSTransition, {
      in: !!minQuantity,
      timeout: 500,
      classNames: appearAnimationClasses,
      unmountOnExit: true
    }, /*#__PURE__*/React.createElement(FilterItemComponent, {
      color: secondaryColor,
      filterItem: minQuantity,
      type: Type.RADIOBUTTON
    })), /*#__PURE__*/React.createElement(CSSTransition, {
      in: !!colorFamily,
      timeout: 500,
      classNames: appearAnimationClasses,
      unmountOnExit: true
    }, /*#__PURE__*/React.createElement(FilterItemComponent, {
      color: secondaryColor,
      filterItem: colorFamily,
      type: Type.COLOR_CIRCLES
    })), /*#__PURE__*/React.createElement(CSSTransition, {
      in: !!productionTime,
      timeout: 500,
      classNames: appearAnimationClasses,
      unmountOnExit: true
    }, /*#__PURE__*/React.createElement(FilterItemComponent, {
      color: secondaryColor,
      filterItem: productionTime,
      type: Type.RADIOBUTTON
    })), /*#__PURE__*/React.createElement(TransitionGroup, {
      component: React.Fragment
    }, productAttributes.map(item => /*#__PURE__*/React.createElement(CSSTransition, {
      key: item.filterId,
      timeout: 500,
      classNames: appearAnimationClasses,
      unmountOnExit: true
    }, /*#__PURE__*/React.createElement(FilterItemComponent, {
      isAttributes: !nonDataIsAttributeFilters.some(filter => filter === item.filterId),
      color: secondaryColor,
      filterItem: item,
      type: item.type
    }))))));
  }
}
export default FilterList;